import getConfig from "next/config";

// publicRuntimeConfig is available for both of Client and Server sides.
// serverRuntimeConfig is available only for Client side.
export const {
  publicRuntimeConfig: nextClientAndServerConfig,
  serverRuntimeConfig: nextServerConfig,
} = getConfig();

export default nextClientAndServerConfig;
